import { createSlice } from '@reduxjs/toolkit'

const initialState = { 
  drawerOpen: false
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setDrawerOpen(state, action) {
      state.drawerOpen = action.payload
    }
  }
})

export const { setDrawerOpen } = uiSlice.actions
export const uiSelector = state => state.ui